export const styles = theme => ({
    bigAvatar: {
        background: theme.palette.primary.main,
        boxShadow: theme.shadows[2],
        width: 70,
        height: 70,
        [theme.breakpoints.up('md')]: {
            width: 80,
            height: 80,
        },
    },
    dialogTitle: {
        flexGrow: 1,
        fontSize: '15px',
        lineHeight: 'inherit',
        paddingBottom: "8px",
    },
    itemsPaper: {
        backgroundColor: 'white !important',
        marginBottom: '2px',
        padding: `${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px ${theme.spacing.unit * 1.5}px`,
        [theme.breakpoints.up('md')]: {
            padding: "25px 15px 25px 30px",
        }
    },
    buttonCard: {
        alignSelf: 'self-start',
        boxShadow: theme.shadows[2],
        borderRadius: '50%',
        paddingBottom: '0px',
        paddingTop: '0px',
        paddingLeft: 0,
        display: 'block',
        zIndex: 0,
        overflow: 'hidden',
    },
    itemDiv: {
        display: 'flex',
        padding: '20px',
        backgroundColor: 'white',
        marginBottom: ' 2px',
        cursor: 'pointer'
    },
    notificationsIcon: {
        width: '50px',
        height: '50px',
    },
    transparentAvatar: {
        backgroundColor: 'transparent',
        width: 50,
        height: 50,
        display: 'block',
    },
    addDialogFabButton: {
        position: 'fixed',
        bottom: 20,
        right: 20,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    emptyTypography: {
        fontSize: 14,
        marginTop: '20px',
        color: 'rgba(0, 0, 0, 0.40)',
    },
    listContainer: theme.listContainer,
});
